import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';

export function exportWeeklyPdf({ weeks, assignments, employees, projects, costCenters, holidays, filename }) {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const empById = Object.fromEntries(employees.map(e => [e.id, e]));
  const projById = Object.fromEntries(projects.map(p => [p.id, p]));
  const kstById = Object.fromEntries(costCenters.map(c => [c.id, c]));

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.text('Einsatzplanung Friedrichs Dach – Wochenplan', 14, 12);
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  const first = format(weeks[0].days[0], 'dd.MM.yyyy', { locale: de });
  // Letzter Tag der Woche, nicht starr Index 5: Mit eingeblendetem Sonntag
  // hat eine Woche sieben Tage, und der Zeitraum im Kopf wäre sonst falsch.
  const letzteWoche = weeks[weeks.length - 1];
  const last = format(letzteWoche.days[letzteWoche.days.length - 1], 'dd.MM.yyyy', { locale: de });
  doc.text(`Zeitraum: ${first} – ${last}`, 14, 17);

  for (let wi = 0; wi < weeks.length; wi++) {
    const w = weeks[wi];
    if (wi > 0) doc.addPage('a4', 'landscape');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text(`KW ${w.isoWeek} – ${format(w.days[0], 'dd.MM.', { locale: de })} bis ${format(w.days[w.days.length - 1], 'dd.MM.', { locale: de })}`, 14, wi === 0 ? 24 : 12);
    const head = [['KSt', ...w.days.map(d => format(d, 'EEE dd.MM.', { locale: de }))]];
    const rows = [];
    costCenters.filter(c => !c.deleted && c.active).forEach(kst => {
      const row = [`${kst.short_code}`];
      w.days.forEach(day => {
        const iso = format(day, 'yyyy-MM-dd');
        const list = assignments.filter(a => {
          const emp = empById[a.employee_id];
          const proj = projById[a.project_id];
          if (!emp || !proj) return false;
          const homeKst = emp.cost_center_id;
          const projKst = proj.cost_center_id;
          return a.date === iso && (homeKst === kst.id || projKst === kst.id || a.lending_target_cost_center_id === kst.id);
        });
        const entries = list.map(a => {
          const e = empById[a.employee_id];
          const p = projById[a.project_id];
          return `${e.first_name[0]}.${e.last_name} (${p.name.substring(0, 15)})`;
        });
        const hol = holidays[iso];
        row.push(hol ? `(${hol.name})` : entries.join('\n'));
      });
      rows.push(row);
    });
    autoTable(doc, {
      head, body: rows, startY: wi === 0 ? 28 : 16,
      styles: { fontSize: 7, cellPadding: 1.5, valign: 'top' },
      headStyles: { fillColor: [234, 238, 245], textColor: [15, 23, 42] },
      columnStyles: { 0: { cellWidth: 20, fontStyle: 'bold' } },
      margin: { left: 8, right: 8 },
    });
  }

  doc.save(filename || 'Einsatzplan.pdf');
}
